module.exports = __webpack_public_path__ + "img/icon-online.6014f738.svg";